import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative overflow-hidden py-12 sm:py-16 px-4 sm:px-6" style={{background: 'linear-gradient(160deg, #0a1628 0%, #0d1f3c 50%, #111e3a 100%)'}}>
      <div className="absolute inset-0 opacity-[0.04]" style={{backgroundImage: 'linear-gradient(108deg, transparent 42%, #c9a227 43%, #c9a227 43.4%, transparent 44%), linear-gradient(72deg, transparent 60%, #c9a227 61%, #c9a227 61.3%, transparent 62%)', backgroundSize: '400px 400px'}}></div>
      <div className="absolute top-0 left-0 right-0 h-px" style={{background: 'linear-gradient(90deg, transparent, #c9a227, transparent)'}}></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 sm:gap-12 mb-10 sm:mb-12">
          <div className="col-span-2 sm:col-span-1">
            <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
              <span className="text-3xl sm:text-4xl">🏡</span>
              <span className="text-xl sm:text-2xl font-bold text-[#c9a227]">홈&그레이브</span>
            </div>
            <p className="text-xs sm:text-sm text-white/55 leading-relaxed">
              진주 지역 전원주택 관리 &amp;<br />
              산소 통합 케어 전문
            </p>
          </div>

          <div>
            <h4 className="text-sm sm:text-lg font-bold mb-3 sm:mb-4 text-[#c9a227]">서비스</h4>
            <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm text-white/55">
              {['전원주택 정원 관리', '전원주택 제초 서비스', '계절별 유지보수', '벌초 대행', '묶음 벌초 할인', '전문 석축/보수'].map((item, i) => (
                <li key={i}>
                  <button onClick={() => scrollToSection('services')} className="hover:text-[#c9a227] transition-colors cursor-pointer text-left">
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm sm:text-lg font-bold mb-3 sm:mb-4 text-[#c9a227]">기술 시스템</h4>
            <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm text-white/55">
              {['10년 위성 사진 분석', '드론 촬영 보고', 'GPS 면적 측정', '21개 투명 요인 견적'].map((item, i) => (
                <li key={i}>
                  <button onClick={() => scrollToSection('features')} className="hover:text-[#c9a227] transition-colors cursor-pointer text-left">
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-2 sm:col-span-1">
            <h4 className="text-sm sm:text-lg font-bold mb-3 sm:mb-4 text-[#c9a227]">문의</h4>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm text-white/55">
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-sm sm:text-base text-[#c9a227]/70"></i>
                </div>
                <span>010-9879-8375</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-sm sm:text-base text-[#c9a227]/70"></i>
                </div>
                <span>contact@home-grave.com</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-sm sm:text-base text-[#c9a227]/70"></i>
                </div>
                <span>경상남도 진주시 문산읍</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t pt-6 sm:pt-8" style={{borderColor: 'rgba(201,162,39,0.15)'}}>
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-xs sm:text-sm text-white/40">
              © 2024 홈&그레이브. All rights reserved.
            </p>
            <div className="flex gap-4 sm:gap-6">
              <a href="#" className="text-xs sm:text-sm text-white/40 hover:text-[#c9a227] transition-colors">이용약관</a>
              <a href="#" className="text-xs sm:text-sm text-white/40 hover:text-[#c9a227] transition-colors">개인정보처리방침</a>
            </div>
          </div>
          <div className="flex justify-center mt-4">
            <button
              onClick={() => navigate('/admin/login')}
              className="text-[10px] text-white/15 hover:text-white/40 transition-colors cursor-pointer"
            >
              관리자
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
